<template>
  <div class="dod-container">
    <div class="settings-panel-wrapper">
      <dod-border-section>
        <template v-slot:section-slot>
          <dod-view-title title="Ustawienia panelu" :pink-title="true" />
        </template>
      </dod-border-section>
      <DodSettingPreviewPanel
        title="Lista wydziałów"
        :options="dodDepartments.data"
        settingKey="DEPARTMENT"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        title="Zakres opieki"
        :options="dodScopesOfCare.data"
        settingKey="SCOPE_OF_CARE"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        title="Status priorytetów"
        :options="dodPriorities.data"
        settingKey="PRIORITY_STATUS"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        title="Statusy podopiecznego"
        :options="customerStatuses"
        settingKey="CUSTOMER_STATUS"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        title="Statusy opiekuna"
        :options="employeeStatuses"
        settingKey="EMPLOYEE_STATUS"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        title="Nazwy kategorii zadań"
        :options="tasksCategories.data"
        settingKey="TASK_CATEGORY"
        @onEdit="openSetting"
      />
      <DodSettingPreviewPanel
        v-if="isSettlementAdmin"
        title="Uprawnienia użytkowników"
        settingKey="PANEL_ROLES"
        @onEdit="openRoles"
      />
    </div>

    <dod-panel-roles
      v-if="isSettlementAdmin && showRoles"
      @close="showRoles = false"
    />
    <div
      v-if="activeSetting"
      class="setting-edit-modal settings-panel-wrapper"
      :key="customSettingKey"
    >
      <dod-view-title :title="activeSetting.title" :pink-title="true" />
      <div
        v-for="setting in activeSetting.options"
        :key="setting.id"
        class="p-0 flex setting-wrapper"
      >
        <div class="p-0" style="min-width: 100px">
          <p class="order-header">KOLEJNOŚĆ</p>
          <custom-select
            :options="
              activeSetting.options.map((e) => ({
                name: e.order,
                value: e.order,
                shortName: e.order,
              }))
            "
            :prePick="setting.order"
            :graySelect="true"
            :large="true"
            @newPick="(val) => handleChangeOrder(setting.id, val)"
          />
        </div>
        <div class="p-0" style="width: 100%">
          <p class="order-header p-0">NAZWA</p>
          <input
            type="text"
            v-model="setting.name"
            :placeholder="setting.name"
          />
        </div>
        <div class="delete-btn-wrapper">
          <CustomButton
            size="small"
            title="Usuń"
            :pink="true"
            style="height: 35px"
            @click="handleDeleteSetting(setting.id)"
          />
        </div>
      </div>
      <div>
        <DodCustomAddButton
          title="Dodaj Nowe Pole"
          @click="handleAddNewSetting"
        />
      </div>
      <div class="p-0 flex btns-wrapper">
        <CustomButton
          size="large"
          title="Anuluj"
          :gray="true"
          @click="activeSetting = null"
        />
        <CustomButton size="large" title="Zapisz" @click="handleSaveSetting" />
      </div>
    </div>

    <div class="block-date-container">
      <p class="label">Zablokuj zmiany</p>
      <div class="select-date">
        <p class="mt-3">Zablokuj zmiany do:</p>
        <datepicker
          :monday-first="true"
          :language="pl"
          v-model="blockChangesDate"
          :placeholder="'Wybierz datę'"
        ></datepicker>
      </div>
      <div class="m-0 p-0 d-flex">
        <custom-button
          class="mr-2"
          size="small"
          :white="true"
          title="Anuluj"
          @click="resetDate()"
        />
        <custom-button
          size="small"
          title="Zapisz"
          @click="saveChangeBlockDate()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import DodBorderSection from "../../components/dod/DodBorderSection.vue";
import DodSettingPreviewPanel from "../../components/dod/DodSettingPreviewPanel.vue";
import CustomButton from "../../components/CustomButton.vue";
import CustomSelect from "../../components/CustomSelect.vue";
import DodCustomAddButton from "../../components/dod/DodCustomAddButton.vue";
import DodPanelRoles from "../../components/dod/settlement/DodPanelRoles.vue";
import { pl } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  components: {
    DodViewTitle,
    DodBorderSection,
    DodSettingPreviewPanel,
    CustomButton,
    CustomSelect,
    DodCustomAddButton,
    Datepicker,
    DodPanelRoles,
  },
  data() {
    return {
      activeSetting: null,
      customSettingKey: new Date().getTime(),
      blockChangesDate: null,
      showRoles: false,
      pl,
    };
  },
  methods: {
    // Only one settings editor is open at a time - opening any of them closes the other.
    openSetting(val) {
      this.showRoles = false;
      this.activeSetting = val;
    },
    openRoles() {
      this.activeSetting = null;
      this.showRoles = true;
    },
    resetDate() {
      this.blockChangesDate = null;
    },
    async saveChangeBlockDate() {
      if (this.blockChangesDate && this.changeBlockDateSettingsDate?.id) {
        await this.$store.dispatch("setDodAppSettingsByName", {
          id: this.changeBlockDateSettingsDate.id,
          name: "CHANGE_BLOCK_DATE",
          value: moment(this.blockChangesDate).format("YYYY-MM-DD"),
        });

        this.$notify({
          group: "success",
          text: "Data blokady zmian została zapisana",
        });
      }
    },

    async handleSaveSetting() {
      if (this.activeSetting.options.every((setting) => setting.name)) {
        await this.$store.dispatch(`updateSettingsByType`, {
          type: this.activeSetting.key,
          data: this.activeSetting.options.map((option) => {
            return {
              id: option.id,
              name: option.name,
              order: option.order,
            };
          }),
        });

        if (this.activeSetting.key === "DEPARTMENT") {
          await this.$store.dispatch("getDodDepartments");
        } else if (this.activeSetting.key === "SCOPE_OF_CARE") {
          await this.$store.dispatch("getDodScopesOfCare");
        } else if (this.activeSetting.key === "PRIORITY_STATUS") {
          await this.$store.dispatch("getDodPriorities");
        } else if (this.activeSetting.key === "CUSTOMER_STATUS") {
          await this.$store.dispatch("fetchCustomerStatuses");
        } else if (this.activeSetting.key === "EMPLOYEE_STATUS") {
          await this.$store.dispatch("fetchEmployeeStatuses");
        } else if (this.activeSetting.key === "TASK_CATEGORY") {
          await this.$store.dispatch("getDodTasksCategories");
        }

        this.activeSetting = null;
      } else {
        this.$notify({
          group: "error",
          text: "Wszystkie pola muszą być wypełnione",
        });
      }
    },
    handleChangeOrder(id, newOrder) {
      const optionIndex = this.activeSetting.options.findIndex(
        (e) => e.id === id
      );
      if (optionIndex !== -1) {
        //get order of setting with value to change
        const previousSettingOrder = parseInt(
          this.activeSetting.options.at(optionIndex).order
        );
        // get index of setting with the same order as newOrder
        const settingIndexToOrderSwap = this.activeSetting.options.findIndex(
          (e) => e.order === newOrder
        );
        // change order of setting with new value
        this.activeSetting.options.at(optionIndex).order = parseInt(newOrder);
        // change order of setting with previous value of changed setting
        this.activeSetting.options.at(settingIndexToOrderSwap).order =
          previousSettingOrder;
        // sort option by order
        this.activeSetting.options = this.activeSetting.options.toSorted(
          (a, b) => a.order - b.order
        );
      }
      this.customSettingKey = new Date().getTime();
    },
    handleDeleteSetting(id) {
      this.activeSetting.options = this.activeSetting.options
        .filter((setting) => setting.id !== id)
        .map((setting, index) => ({
          ...setting,
          order: index + 1,
        }));
      this.customSettingKey = new Date().getTime();
    },
    handleAddNewSetting() {
      // Gdy lista jest pusta (np. świeża baza POD) options.at(0) jest undefined -
      // typ bierzemy z klucza panelu (activeSetting.key == SETTINGS_TYPE).
      const settingType =
        this.activeSetting.options.at(0)?.type || this.activeSetting.key;
      this.activeSetting.options.push({
        disabledRemoving: false,
        name: "",
        order: this.activeSetting.options.length + 1,
        type: settingType,
      });
      this.customSettingKey = new Date().getTime();
    },
  },
  async created() {
    await this.$store.dispatch(
      "fetchDodAppSettingsByName",
      "CHANGE_BLOCK_DATE"
    );
    await this.$store.dispatch("getDodDepartments");
    await this.$store.dispatch("getDodScopesOfCare");
    await this.$store.dispatch("getDodPriorities");
    await this.$store.dispatch("getDodTasksCategories");
    await this.$store.dispatch("fetchCustomerStatuses");
    await this.$store.dispatch("fetchEmployeeStatuses");
    if (this.changeBlockDateSettingsDate) {
      this.blockChangesDate = this.changeBlockDateSettingsDate.value;
    }
  },
  computed: {
    dodDepartments() {
      return this.$store.getters.getDodDepartments;
    },
    dodScopesOfCare() {
      return this.$store.getters.getDodScopesOfCare;
    },
    dodPriorities() {
      return this.$store.getters.getDodPriorities;
    },
    tasksCategories() {
      return this.$store.getters.getDodTasksCategories;
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    changeBlockDateSettingsDate() {
      return this.$store.getters.getDODAppSettings;
    },
    isSettlementAdmin() {
      return this.$store.getters.getIsSettlementAdmin;
    },
  },
};
</script>

<style scoped>
.settings-panel-wrapper {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
  padding: 10px 20px !important;
  min-width: 1024px;
}

.setting-edit-modal {
  margin-top: 20px;
  padding: 30px 20px !important;
  margin-bottom: 50px;
}
.btns-wrapper {
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.setting-wrapper {
  margin-bottom: 10px;
  gap: 10px;
}
.order-header {
  margin-bottom: 0;
  color: #090741;
  font-size: 12px;
  padding-left: 5px;
  font-weight: 500;
}
input[type="text"] {
  border: 1px solid #c1c1cf;
  padding: 5px;
  border-radius: 5px;
  height: 35px;
  width: 100%;
  margin-top: 5px;
}
.delete-btn-wrapper {
  height: fit-content;
  padding: 0;
  margin-top: 8px;
  align-self: center;
}
.label {
  color: #e2037e;
  font-size: 22px;
  line-height: 33px;
}
.select-date {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin: 0;
  padding: 0;
}
.block-date-container {
  margin-top: 2rem;
  padding-bottom: 8rem;
}
</style>
